let alertHeader = $('.js-alert-header');
let alertHeaderClose = $('.js-alert-header-close');
let alertBody= $('.alert-header')

$(function () {

    alertHeaderClose.on('click', function () {
        alertHeader.slideUp(150);
        alertBody.removeClass('alert-header');
        
    });
})